var {AmpersandCollection} = require('catalog/libs');

var HPEServices = require('../../../base/hpe.services');
var HPEConstants = require('../../../base/hpe.constants');
var ProductModal = require('../../../base/hpe.product.model');

var specListModel = require('./hpe.productlist.productcard.speclist.model');

var specListCollectionFirstThird = AmpersandCollection.extend({
    model: specListModel,
    parse: function (response) {
        return response.slice(0, Math.ceil(response.length / 2));
    }
});

var specListCollectionLastThird = AmpersandCollection.extend({
    model: specListModel,
    parse: function (response) {
        return response.slice(Math.ceil(response.length / 2), response.length);
    }
});

 /**
 * state properties
 */
var ProductCardProps = {
    props: {
        'labelCompare': 'string',
        'labelPrice': 'string',
        'labelNew': 'string',
        'labelUpdated': 'string',
        'showSpecs': ['boolean', false, true],
        'sku': 'string',
        'category': 'string',
        'subcategory': 'string',
        'categoryLabel': 'string',
        'cta': 'string',
        'ctaURL': 'string',
        'productURL': 'string',
        'compare': 'boolean',
        'price_vat': 'string',
        'primaryPrice': 'string',
        'secondaryPrice': 'string',
        'primaryPriceLabel': 'string',
        'secondaryPriceLabel': 'string',
        'isCompareChecked': ['boolean', false, false],
        'isCompareDisabled': ['boolean', false, false],
        'specsCollection1Length': ['number', false, 0],
        'specsCollection2Length': ['number', false, 0]
    },

    /**
     * derived properties
     */
    derived: {
        compareId: {
            deps: ['oid'],
            fn: function() {
                return 'compare' + this.oid;
            }
        },
        specsEmpty: {
            deps: ['specsCollection1Length', 'specsCollection2Length'],
            fn: function() {
                return ((this.specsCollection1Length + this.specsCollection2Length) === 0);
            }
        }
    },

    /**
     * child models
     */
    children: {
        speclistFirstThird: specListCollectionFirstThird,
        speclistLastThird: specListCollectionLastThird
    },

    /**
     * initialization
     */
    initialize: function() {

        var that = this;

        this.speclistFirstThird.on('add', function() {
            that.specsCollection1Length = that.speclistFirstThird.length;
        });

        this.speclistLastThird.on('add', function() {
            that.specsCollection2Length = that.speclistLastThird.length;
        });
    }
};

/**
 * Product Card Collection
 */
var productCardCollection = AmpersandCollection.extend({

    mainIndex: 'oid',

    model: ProductModal.ProductBaseModel.extend(ProductCardProps),

    /**
     * collection initialization
     */
    initialize: function() {

        //event listeners
        HPEServices.subscribe(HPEConstants.catalog.COMPARE_LIST_REMOVE, this, function(oid) {
            var item;
            if (oid) {
                item = this.get(oid);
                if (item) {
                    item.set('isCompareChecked', false);
                }
            }
        });
        HPEServices.subscribe(HPEConstants.catalog.COMPARE_LIST_ADD, this, function(product) {
            var item;
            if (product && product.oid) {
                item = this.get(product.oid);
                if (item) {
                    item.set('isCompareChecked', true);
                }
            }
        });
    }
});

module.exports = productCardCollection;
